import React, { PropTypes } from 'react';
import RenderField from '../../../FormTemplate/InputControl';
import { Field } from 'redux-form';
import { Button, Table } from 'react-bootstrap';
import alert from 'alertify.js';
import axios from './../../../../constants/axios';

class RenderLists extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         itemLists: [],
      };
   }

   barcodeInputOnEnter = (e) => {
      if (e.keyCode === 13 && e.target.value) {
         // search for barcode. If found, push items
         return axios.get('inventoryPurchases/itemSearchByBarcode/' + e.target.value)
            .then((res) => {
               if (res.status === 200) {
                  // Ok Item found. Push it;
                  this.addItemOnList(res.data);
               }
               this.clearBarcodeField();
            })
            .catch((err) => {
               if (err && err.response && err.response.status === 422) {
                  alert.error(err.response.data);
               }
               this.clearBarcodeField();
            });
      }
   };

   clearBarcodeField = () => {
      this.refs.barcode.value = '';
      this.refs.barcode.focus();
   };

   addItemOnList = (item) => {
      const findIndex = this.props.items ? this.props.items.findIndex((itm) => itm.item_id === item.id) : -1;
      if (findIndex > -1) {
         const oldUnit = this.props.items[findIndex].unit;
         const oldPrice = this.props.items[findIndex].price;

         this.props.fields.remove(findIndex);
         this.props.fields.push({
            item_id: item.id,
            name: item.name,
            unit: oldUnit + 1,
            price: oldPrice,
         });
      } else {
         this.props.fields.push({
            item_id: item.id,
            name: item.name,
            unit: 1,
         });
      }
   };

   searchProductByName = (e) => {
      // search for barcode. If found, push items
      return axios.get('inventoryPurchases/itemSearchByName/' + e.target.value)
         .then((res) => {
            this.setState({
               itemLists: res.data,
            });
         })
         .catch(() => {
         });
   };

   clickOnItem = (item) => {
      this.addItemOnList(item);
      this.refs.nameSearch.value = '';
      this.setState({
         itemLists: [],
      });
   };

   render() {
      const { fields, items } = this.props;
      const { itemLists } = this.state;

      return (
         <div >
            <Table >
               <thead >
               <tr >
                  <th >ItemId</th >
                  <th >Item Name</th >
                  <th >Unit</th >
                  <th >Total</th >
                  <th >P.Price</th >
               </tr >
               </thead >
               <tbody >
               {fields.map((item, index) =>
                  <tr key={index} >
                     <td className="col-md-1" >
                        <Field
                           name={`${item}.item_id`}
                           type="number"
                           disabled
                           component={RenderField} />
                     </td >
                     <td className="col-md-7" >
                        <Field
                           name={`${item}.name`}
                           type="text"
                           disabled
                           component={RenderField} />
                     </td >
                     <td className="col-md-1" >
                        <Field
                           name={`${item}.unit`}
                           type="number"
                           component={RenderField} />
                     </td >
                     <td className="col-md-2" >
                        <Field
                           name={`${item}.total`}
                           type="number"
                           component={RenderField} />
                     </td >
                     <td >
                        {items && items.length > 0 && items[index] && items[index].price && items[index].price}
                     </td >
                     <td >
                        {<Button onClick={() => fields.remove(index)} >remove</Button >}
                     </td >
                  </tr >
               )}
               </tbody >
            </Table >
            <span >
                           Barcode: <input ref="barcode" placeholder="Scan Barcode" type="text" name="barcode"
                                           onKeyDown={(e) => this.barcodeInputOnEnter(e)} />
            </span >
            <span >
                           Name Search: <input ref="nameSearch" placeholder="Search Products" type="text"
                                               name="nameSearch"
                                               onKeyDown={(e) => this.searchProductByName(e)} />
               {itemLists &&
               <ul className="renderInventoryCounterListUl" >
                  {itemLists.map((item) => <li key={item.id} onClick={() => this.clickOnItem(item)}
                                               className="renderInventoryCounterListItem" >{item.name}</li >)}
               </ul >
               }
            </span >
         </div >
      );
   }
}

RenderLists.propTypes = {
   fields: PropTypes.object,
   items: PropTypes.array
};

export default RenderLists;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Purchase/Helper/RenderLists.js
 **/